import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BotCommunity from "@/pages/BotCommunity";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BotCommunity />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
